var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7005 51.8139C40.3829 51.8139 51.4748 40.4388 51.4748 26.4069C51.4748 12.3751 40.3829 1 26.7005 1C13.018 1 1.92615 12.3751 1.92615 26.4069C1.92615 40.4388 13.018 51.8139 26.7005 51.8139Z",
    fill: "#F0FBFF",
    stroke: "#00A4BF",
    strokeWidth: 1.89601
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7321 46.1198C24.0327 46.366 25.356 46.494 26.7018 46.5037C37.5253 46.5037 46.2994 37.5055 46.2994 26.4056C46.2994 15.3058 37.5253 6.30762 26.7018 6.30762C23.9215 6.30762 21.2763 6.9014 18.8804 7.97207C14.7169 9.83264 11.306 13.1333 9.24592 17.2606C7.87669 20.0038 7.10425 23.1122 7.10425 26.4056C7.10425 29.3938 7.74014 32.2297 8.88071 34.7786C9.69499 36.5984 10.7665 38.272 12.0475 39.7504",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7321 46.1198C24.0327 46.366 25.356 46.494 26.7018 46.5037C37.5253 46.5037 46.2994 37.5055 46.2994 26.4056C46.2994 15.3058 37.5253 6.30762 26.7018 6.30762C23.9215 6.30762 21.2763 6.9014 18.8804 7.97207C14.7169 9.83264 11.306 13.1333 9.24592 17.2606C7.87669 20.0038 7.10425 23.1122 7.10425 26.4056C7.10425 29.3938 7.74014 32.2297 8.88071 34.7786C9.69499 36.5984 10.7665 38.272 12.0475 39.7504",
    stroke: "#00A4BF",
    strokeWidth: 1.89601,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3472 42.0146C15.9358 43.3388 17.7305 44.413 19.6743 45.1787",
    stroke: "#00A4BF",
    strokeWidth: 1.89601,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0375 46.5059L51.4747 51.0564",
    stroke: "#00A4BF",
    strokeWidth: 1.89601
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7572 50.3178C49.3575 51.7533 49.3575 54.0806 50.7572 55.5161L58.9551 63.9234C60.3548 65.3588 62.6242 65.3588 64.024 63.9234C65.4237 62.4879 65.4237 60.1605 64.024 58.7251L55.826 50.3178C54.4263 48.8823 52.1569 48.8823 50.7572 50.3178Z",
    fill: "#F0FBFF",
    stroke: "#00A4BF",
    strokeWidth: 1.89601
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4329 51.8145L62.5678 60.157",
    stroke: "white",
    strokeWidth: 1.89601,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8937 17.6829C21.8937 26.479 28.8468 33.6097 37.4239 33.6097C39.1088 33.6097 40.731 33.3345 42.2502 32.8256C39.7705 39.1363 33.7429 43.5909 26.7007 43.5909C17.4453 43.5909 9.94238 35.8964 9.94238 26.4047C9.94238 17.8039 16.103 10.6788 24.1456 9.41699C22.7168 11.8274 21.8937 14.6566 21.8937 17.6829Z",
    fill: "#F0FBFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.071 12.376C26.1293 12.376 25.2092 12.471 24.3194 12.6522M21.6316 13.4955C16.5725 15.6757 13.0199 20.8053 13.0199 26.7859",
    stroke: "#00BADB",
    strokeWidth: 1.89601,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPick);
export default __webpack_public_path__ + "static/media/pick.21b8ca5fe42306be17977b6b1792cbc0.svg";
export { ForwardRef as ReactComponent };